module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_latte_Front_10.88c04041.png";